import { connect } from 'react-redux';

import {
    HeaderUserInfo,
    HeaderUserInfoProps
} from '../../components/HeaderUserInfo/HeaderUserInfo';
import {
    selectAdditionalUserInfo,
    selectHeaderActionsMenu
} from '../../selectors/header/header';
import { GlobalSettings } from '../../service/GlobalSettings/GlobalSettings';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

interface OwnProps {
    cls?: string;
}

export type StateProps = TStateProps<HeaderUserInfoProps, OwnProps>;

export const mapStateToProps = (state: State): StateProps => {
    const {
        devInfo: { isProduction },
        header: { userAccountsInfo, role, isAgency }
    } = state;
    const additionalUserInfo = selectAdditionalUserInfo(state);

    return {
        isProduction,
        userAccountsInfo: userAccountsInfo,
        role,
        isAgency,
        yu: GlobalSettings.yu,
        passportUrl: GlobalSettings.passportUrl,
        actionsMenu: selectHeaderActionsMenu(state),
        additionalUserInfo
    };
};

const mapDispatchToProps = () => {
    return {};
};

export const HeaderUserInfoContainer = connect<StateProps, {}, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(HeaderUserInfo);
